import {Component, effect, inject} from '@angular/core';
import {GameStore} from '../../store/game.store';
import {QuestionFeedback} from '../../models/game-models.model';
import {ResourcesService} from '../../services/resources.service';

@Component({
  selector: 'gis-question-feedback',
  templateUrl: './question-feedback.component.html',
  styleUrl: './question-feedback.component.scss'
})
export class QuestionFeedbackComponent {
  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  feedbackValue: QuestionFeedback = null;
  visible: string | null = null;
  isFinalStatus = false;

  constructor() {
    effect(() => {
      this.feedbackValue = this.store.questionState().feedback ?? null;

      // to trigger screenreaders to announce feedback even when feedback remains equal between two answers
      // but only the first time when the questionState.feedback becomes 'correct' or 'wrong-and-over'
      if (!this.isFinalStatus) {
        this.visible = null;
        setTimeout(() => {
          this.visible = 'visible';
        });
        this.isFinalStatus = this.feedbackValue === 'correct' || this.feedbackValue === 'wrong-and-over';
      }
    });
  }

  computeScore() {
    return this.store.earnedPointsForCurrentQuestion();
  }
}
